import { render } from "./NeedToKnowLenta.vue?vue&type=template&id=1f853ffb&scoped=true"
import script from "./NeedToKnowLenta.vue?vue&type=script&lang=js"
export * from "./NeedToKnowLenta.vue?vue&type=script&lang=js"

import "./NeedToKnowLenta.vue?vue&type=style&index=0&id=1f853ffb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f853ffb"]])

export default __exports__